var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrapper",staticClass:"displacement-image-wrapper"},[_c('div',{ref:"inject",staticClass:"displacement-injector",attrs:{"id":"inject-displacement-image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }